import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import { SkillResponse } from "./data";
import { apiGetSkills } from "./service";

export const useGetSkills = (options: any) => {
  return useQuery<SkillResponse[]>({
    queryKey: [queryKey.SKILL_LIST],
    queryFn: () =>
      apiGetSkills().then((res: ApiResponse<SkillResponse[]>) => res.data.data),
    ...options,
  });
};
